import { makeStyles } from "@fluentui/react-components";
import { $white } from "../../cssjs/colors";
import { FlightCard } from "../shared/components/airport-cards/FlightCard";
import { FlightTabs } from "../shared/components/airport-cards/flights/FlightTabs";

export const OverviewCarousel: React.FC<any> = (props) => {
  const classes = useClasses();

  return (
    <section className={classes.container}>
      <FlightCard
        key="carouselFlightCard"
        isCarousel={true}
        airportCode={props.airportCode}
      />
      <FlightTabs key="carouselFlightDetailsCard" />
    </section>
  );
};

const useClasses = makeStyles({
  container: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr",
    minHeight: "640px",
    background: $white,
    height: "73vh",
    "@media (max-width: 768px)": {
      minHeight: "480px",
    },
  },
});
